import { useState } from 'react';
import { api, type User } from '../api.ts';
import { initialsOf, logoUrl, useCompany } from '../company.ts';
import PasswordInput from '../components/PasswordInput.tsx';

export default function Login({ onSignedIn }: { onSignedIn: (u: User) => void }) {
  const company = useCompany();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const res = await api.post<{ user: User }>('/api/auth/login', { username, password });
      onSignedIn(res.user);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not sign in');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login panel" onSubmit={submit} style={{ padding: 22 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
          {/* The name on the door, which is how somebody checks they are at
              the right one -- so it is read before signing in, not after. */}
          <div className={`brand-mark${company.hasLogo ? ' has-logo' : ''}`}>
            {company.hasLogo
              ? <img src={logoUrl(company)} alt="" />
              : initialsOf(company.name)}
          </div>
          <div>
            <h1>{company.name}</h1>
            <p className="sub" style={{ margin: 0 }}>{company.tagline}</p>
          </div>
        </div>

        {error && <div className="error">{error}</div>}

        <div className="field">
          <label htmlFor="u" className="req">Username</label>
          <input id="u" type="text" autoFocus autoComplete="username"
                 value={username} onChange={(e) => setUsername(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="p" className="req">Password</label>
          <PasswordInput id="p" value={password} onChange={setPassword}
                         autoComplete="current-password" />
        </div>

        <button className="btn primary" style={{ width: '100%', padding: 8 }}
                disabled={busy || !username || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
